import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'
import { MerchantData } from './insertMerchant'

const RECON_CHANNEL_ID = window?._env_?.REACT_APP_RECON_CHANNEL_ID ?? ''
const MTS_CHANNEL_ID = window?._env_?.REACT_APP_MTS_CHANNEL_ID ?? ''
const DMM_CHANNEL_ID = window?._env_?.REACT_APP_DMM_CHANNEL_ID ?? ''

const getMerchantRequestBody = (mid: string) => {
  const reqBody = {
    mid,
    configListDetails: [
      {
        key: 'ALLOWED_CHANNEL',
        value: '9081',
      },
      {
        key: 'ALLOWED_CHANNEL',
        value: '6163',
      },
      {
        key: 'ALLOWED_CHANNEL',
        value: RECON_CHANNEL_ID,
      },
      {
        key: 'ALLOWED_CHANNEL',
        value: MTS_CHANNEL_ID,
      },
      {
        key: 'ALLOWED_TXN_TYPE',
        value: '212',
      },
      {
        key: 'ALLOWED_TXN_TYPE',
        value: '110',
      },
    ],
  }
  if (DMM_CHANNEL_ID) {
    reqBody.configListDetails.push({
      key: 'ALLOWED_CHANNEL',
      value: DMM_CHANNEL_ID,
    })
  }
  return reqBody
}

const addMerchantConfigList = (merchantData: MerchantData, tokens: any) => {
  let requestBody
  if (!!merchantData.configList) {
    let configJson
    try {
      configJson = JSON.parse(merchantData.configList)
    } catch (e) {
      throw {
        data: {
          error: {
            code: '400',
            message: 'Invalid JSON',
          },
        },
      }
    }
    requestBody = {
      mid: merchantData.mid,
      configListDetails: configJson,
    }
  } else {
    requestBody = getMerchantRequestBody(merchantData.mid)
  }
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.addMerchantConfigList,
    body: requestBody,
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    if (data?.data?.status === 'SUCCESS') {
      return data?.data
    } else {
      throw data
    }
  })
}

export { addMerchantConfigList }
